import React, { useEffect, useState } from "react";
import StepCount from "../components/contactUs/StepCount";
import StepOne from "../components/contactUs/StepOne";
import StepTwo from "../components/contactUs/StepTwo";
import StepThree from "../components/contactUs/StepThree";
import { useTranslation } from "react-i18next";
import { useForm,useWatch  } from 'react-hook-form';  // Import the useForm hookimport Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import { useContent } from "../hooks/useContent";
import Header from  "../components/shared/Header";
const ContactUs = () => {
  // ----------- hooks ------------
  const { t, i18n } = useTranslation();
  const [step, setStep] = React.useState(0);
  const { control, handleSubmit, setValue, formState ,getValues, watch  } = useForm(); // Use the useForm hook  
  const { errors } = formState;
  const watchedValue = watch('contact_reason'); 
  const { SendContactUs } = useContent();

   const [isValid1, setIsValid1] = useState(false) 
   const [isValid2, setIsValid2] = useState(false) 
   const [isValid3, setIsValid3] = useState(false) 
  const [stepsData , setData] = useState({})
  const [contact, setContact] = React.useState({
    contact_reason: "",
    type: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    birth_date: "",
    phone: "",
    email: "",
    city: "",
    country: "",
    activity: "",
    additional_info:"",
    company_name:"",
  });
   const check_step1 = () => {
      if( getValues('type') != '' && getValues('contact_reason') != '' ) {

        setIsValid1(true)
        console.log(false == undefined);
      }
      
    }
    const check_step2 = () => {
      if( 
      getValues('first_name')
      &&
       getValues('city')
       && 
       getValues('middle_name')
       &&
        getValues('last_name')
        && 
        getValues('birth_date')
        && 
        getValues('phone')
        &&
         getValues('email')
        &&
         getValues('country')
       ) {

        setIsValid2(true)
        console.log(watchedValue);
      }
      
    }

    const check_step3 = () => {
      if( getValues('additional_info')  && getValues('company_name')  && getValues('activity')) {

        setIsValid3(true)
        console.log(watchedValue);
      }
      
    }


     /*  contact.contact_reason = data.contact_reason
      contact.type = data.type
      setContact(contact) */
      
      // Handle your form data here
    //}; 
    // ------------ function ------------
    const watching = () => {
    const inputsValues = {
      contact_reason:getValues('contact_reason'),
      type: getValues('type'),
    first_name: getValues('first_name'),
    middle_name: getValues('middle_name'),
    last_name: getValues('last_name'),
    birth_date: getValues('birth_date'),
    phone: getValues('phone'),
    email: getValues('email'),
    city: getValues('city'),
    country: getValues('country'),
    activity: getValues('activity'),
    additional_info:getValues('additional_info'),
    company_name:getValues('company_name'),
  }
  setContact(inputsValues);
  console.log(contact)
  check_step1();
  check_step2();
  check_step3();

  }
  const handleChange = (item, data) => {
    setContact((prev) => {
      return {
        ...prev,
        [item]: data,
      };
    });
  };
 const sendData = async () => {
  await SendContactUs(contact);
 }
  return (
    <>
    <Header pagetitle={"Contact us"} subtitle={"There are many ways to contact us, and the work team is keen to answer all your questions, inquiries, and opinions."}/>
    <div className="bg-bgGray py-2 md:py-20 text-lg font-medium" style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
    <form onChange={watching}>
      <div className="md:w-4/6 md:mx-auto bg-white rounded-xl p-10">
        
        <div className="flex flex-col md:flex-row gap:10 md:gap-14 items-start">
          
          <StepCount step={step} />
          {step === 0 && (
            <StepOne
            control={control}
            />
          )}
          {step === 1 && (
            <StepTwo
            control={control}

            />
          )}
          {step === 2 && (
            <StepThree
            control={control}
            />
          )}
        </div>
        <div className="flex flex-row justify-between pt-10 md:px-10 ">
          <button
            className={`border text-gray border-bgGray py-2 px-4 rounded-md ${
              step === 0 ? "border text-gray" : "border-black text-black"
            }`}
            disabled={step === 0}
            onClick={() => setStep(step - 1)}
          >
            {t("Previous")}
          </button>
         
          {step == 0 && (


          <button
            className={`bg-gray ${isValid1 ? 'bg-purple': 'bg-gray'} text-white py-2 px-4 rounded-md`}
          
            disabled={!isValid1}
            onClick={() => {setStep(step + 1);}}
          >
            {t("Next")}
          </button>
          )}
              {step == 1 && (

          <button
            className={`bg-gray ${isValid2 ? 'bg-purple': 'bg-gray'} text-white py-2 px-4 rounded-md`}
          
            disabled={!isValid2}
            onClick={() => {setStep(step + 1);}}
          >
            {t("Next")}
          </button>  )}
          {step == 2 && (

          <button
            className={`bg-gray ${isValid3 ? 'bg-purple': 'bg-gray'} text-white py-2 px-4 rounded-md`}
          
            disabled={!isValid3}
            onClick={() => {setStep(step + 1); sendData();}}
          >
            {t("Next")}
          </button>
          )}
        </div>
      </div>
      </form>
    </div>
    <Footer />
    </>
  );
};

export default ContactUs;
